import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './CreateGroupModal.css';

function CreateGroupModal({ selectedTableNumbers, onConfirm, onCancel }) {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setLoading(true);
    try {
      await onConfirm(name.trim());
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{t('tables.createGroup', 'Crear grupo')}</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>{t('tables.groupName')}</label>
              <input
                type="text"
                className="form-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={t('tables.groupNamePlaceholder')}
                autoFocus
              />
            </div>
            <div className="create-group-tables">
              <span className="create-group-tables-label">{t('tables.table')}s:</span>
              <div className="create-group-table-chips">
                {Array.from(selectedTableNumbers).map((tn) => (
                  <span key={tn} className="create-group-chip">
                    {tn}
                  </span>
                ))}
              </div>
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn-ghost" onClick={onCancel}>
              {t('common.cancel', 'Cancelar')}
            </button>
            <button type="submit" className="btn btn-primary" disabled={!name.trim() || loading}>
              {loading
                ? t('common.loading', 'Cargando...')
                : t('tables.createGroup', 'Crear grupo')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateGroupModal;
